<template>

	<app-boards board-key="guide_install"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "guide_install",
	components: {AppBoards}
}
</script>

<style scoped>

</style>